import { Suspense } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import MobileNav from './MobileNav';
import Sidebar from '../dashboard/Sidebar';
import { useAuth } from '@/lib/auth';
import TutorialOverlay from '@/components/tutorial/TutorialOverlay';

function LoadingFallback() {
  return (
    <div className="p-8 animate-pulse">
      <div className="h-8 w-64 bg-neutral-200 rounded mb-4" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-48 bg-neutral-200 rounded" />
        ))}
      </div>
    </div>
  );
}

export default function Layout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <LoadingFallback />;
  }

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100">
      <div className="hidden lg:block lg:fixed lg:inset-y-0 lg:z-50 lg:w-72">
        <Sidebar />
      </div>
      <main className="lg:pl-72">
        <div className="relative min-h-screen pb-16 lg:pb-0">
          <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg')] bg-cover bg-center opacity-20" />
          <div className="relative z-10">
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
        <MobileNav />
      </main>
      <TutorialOverlay />
    </div>
  );
}